import SplitIO from "@splitsoftware/splitio/types/splitio";
import logger from "logging/logger";
import { updateFeatureFlagInContext } from "modules/monitoring";
import { useMemo } from "react";
import {
  EventFeatures,
  UserFeatures,
  CompanyFeatures,
} from "services/splitService/features";
import { TrafficType } from "../constants";
import { parseTreatment, Treatment } from "../treatment";
import { TreatmentResponse } from "../types";
import { ClientStatus, useSplitClient } from "./useSplitClient";

type BaseTreatmentParams = {
  attributes?: SplitIO.Attributes;
  key: string;
};
type UseTreatmentParams =
  | (BaseTreatmentParams & {
      feature: EventFeatures;
      trafficType: TrafficType.EVENT;
    })
  | (BaseTreatmentParams & {
      feature: UserFeatures;
      trafficType: TrafficType.USER;
    })
  | (BaseTreatmentParams & {
      feature: CompanyFeatures;
      trafficType: TrafficType.COMPANY;
    });
export const useTreatment = ({
  feature,
  key,
  trafficType,
  attributes,
}: UseTreatmentParams): TreatmentResponse => {
  const splitClientResult = useSplitClient(key, trafficType);
  const treatment = useMemo(() => {
    logger.info(
      `[split][useTreatment] status is: ${splitClientResult.status} for feature: ${feature}`,
    );
    if (splitClientResult.status === ClientStatus.PENDING) {
      return Treatment.PENDING;
    }

    if (splitClientResult.status === ClientStatus.TIMEOUT) {
      return Treatment.OFF;
    }

    const resolvedTreatment = parseTreatment(
      splitClientResult.client.getTreatment(feature, attributes),
    );
    updateFeatureFlagInContext(feature, resolvedTreatment);
    return resolvedTreatment;
  }, [feature, splitClientResult.status, splitClientResult.client, attributes]);

  return { treatment, featureEnabled: treatment === "on" };
};
